export { VinSearchFooter } from "./VinSearchFooter";
export type { VinSearchFooterProps } from "./VinSearchFooter";
